import go from '@/gojs/go'

import { fromField, locDistribution } from '@/sui/data/caracteristics/tools'
import sc from '@/sui/components/results/sc/observa4'

import t2020 from '@/sui/data/caracteristics/observa4/2020'
import t2021 from '@/sui/data/caracteristics/observa4/2021'
import t2022 from '@/sui/data/caracteristics/observa4/2022'
import t2023 from '@/sui/data/caracteristics/observa4/2023'
import t2024 from '@/sui/data/caracteristics/observa4/2024'
import t2025 from '@/sui/data/caracteristics/observa4/2025'
import t2026 from '@/sui/data/caracteristics/observa4/2026'

import v2020 from '@/sui/data/sheets/edit/observa4/2020'
import v2021 from '@/sui/data/sheets/edit/observa4/2021'
import v2022 from '@/sui/data/sheets/edit/observa4/2022'
import v2023 from '@/sui/data/sheets/edit/observa4/2023'
import v2024 from '@/sui/data/sheets/edit/observa4/2024'
import v2025 from '@/sui/data/sheets/edit/observa4/2025'
import v2026 from '@/sui/data/sheets/edit/observa4/2026'

const yearTables = {
  '2020': t2020,
  '2021': t2021,
  '2022': t2022,
  '2023': t2023,
  '2024': t2024,
  '2025': t2025,
  '2026': t2026
}

const yearFields = {
  '2020': v2020.fields,
  '2021': v2021.fields,
  '2022': v2022.fields,
  '2023': v2023.fields,
  '2024': v2024.fields,
  '2025': v2025.fields,
  '2026': v2026.fields
}

const o4c = go.caracteristics.observa4

function fromGoCarac (carac) {
  const legend = o4c.legends[carac.legend]
  return {
    f: carac.key,
    t: legend.title,
    v: legend.values
  }
}

const indicators = {
  p1: {
    indicators: [
      {
        f: o4c.p1.p1CompliantAuditedOutfitAndHDMInCtr.key,
        t: 'Indicateurs de la stratégie nationale (CVC, PICC, cathéter de dialyse, secteur adulte)',
        h: true
      },
      fromGoCarac(o4c.p1.p1CompliantAuditedOutfitAndHDMInCtr),
      fromGoCarac(o4c.p1.p1CompliantPatientAdultOutfitInCtr),
      fromGoCarac(o4c.p1.p1CompliantAdultSkinPreparationInCtr),

      {
        f: o4c.p1.p1CompliantAuditedOutfitAndHDMInMID.key,
        t: 'Indicateurs SPIADI (MIDLines avec prolongateur intégré, secteur adulte)',
        h: true
      },
      fromGoCarac(o4c.p1.p1CompliantAuditedOutfitAndHDMInMID),
      fromGoCarac(o4c.p1.p1CompliantPatientAdultOutfitInMID),
      fromGoCarac(o4c.p1.p1CompliantAdultSkinPreparationInMID)
    ],

    highlights: [
      {
        f: o4c.p1.p1CompliantAuditedOutfitAndHDM.key,
        t: sc.titles.byTheme.adt,
        h: true
      },
      fromGoCarac(o4c.p1.p1CompliantAuditedOutfitAndHDM),
      fromGoCarac(o4c.p1.p1SterileGown),
      fromGoCarac(o4c.p1.p1CompliantAuditedMask),
      fromGoCarac(o4c.p1.p1CompliantAuditedCap),
      fromGoCarac(o4c.p1.p1CompliantAsepsis),

      {
        f: o4c.p1.p1CompliantPatientAdultOutfit.key,
        t: 'Tenue du patient / résident (adultes)',
        h: true
      },
      fromGoCarac(o4c.p1.p1CompliantPatientAdultOutfit),
      fromGoCarac(o4c.p1.p1PatientAdultCleanOutfit),
      fromGoCarac(o4c.p1.p1CompliantPatientAdultCapOrSterileField),
      fromGoCarac(o4c.p1.p1CompliantPatientAdultMaskOrSterileField),

      {
        f: o4c.p1.p1CompliantAdultSkinPreparation.key,
        t: 'Préparation cutanée (adultes)',
        h: true
      },
      fromGoCarac(o4c.p1.p1CompliantAdultSkinPreparation),
      fromGoCarac(o4c.p1.p1CompliantAdultCleaning),
      fromGoCarac(o4c.p1.p1CompliantAdultCompresses),
      fromGoCarac(o4c.p1.p1AdultChlorexidine2Percent),
      fromGoCarac(o4c.p1.p1AdultSpontaneousDrying),

      {
        f: o4c.p1.p1CompliantUltrasoundAtInsertion.key,
        t: `Échoguidage à l'insertion`,
        h: true
      },
      fromGoCarac(o4c.p1.p1CompliantUltrasoundAtInsertion),
      fromGoCarac(o4c.p1.p1UltrasoundSterileGelAndSheath),
      fromGoCarac(o4c.p1.p1UltrasoundCompliantAsepsis)
    ],

    others: [
      fromGoCarac(o4c.p1.p1CompliantPedCleaning),
      fromGoCarac(o4c.p1.p1AdultAlcoolicAntiseptic)
    ]
  },

  p2: {
    indicators: [
      {
        f: o4c.p2.p2CompliantAuditedOutfitAndHDMInCVP.key,
        t: 'Indicateurs de la stratégie nationale (CVP courts ou MIDLines sans prolongateur intégré, secteur adulte)',
        h: true
      },
      fromGoCarac(o4c.p2.p2CompliantAuditedOutfitAndHDMInCVP),
      fromGoCarac(o4c.p2.p2CompliantAdultSkinPreparationInCVP)
    ],

    highlights: [
      {
        f: o4c.p2.p2CompliantAuditedOutfitAndHDM.key,
        t: sc.titles.byTheme.adt,
        h: true
      },
      fromGoCarac(o4c.p2.p2CompliantAuditedOutfitAndHDM),
      fromGoCarac(o4c.p2.p2AuditedCleanOutfit),
      fromGoCarac(o4c.p2.p2CompliantAsepsis),

      {
        f: o4c.p2.p2CompliantPatientOutfit.key,
        t: 'Tenue du patient / résident',
        h: true
      },
      fromGoCarac(o4c.p2.p2CompliantPatientOutfit),

      {
        f: o4c.p2.p2CompliantAdultSkinPreparation.key,
        t: 'Préparation cutanée',
        h: true
      },
      fromGoCarac(o4c.p2.p2CompliantAdultSkinPreparation),
      fromGoCarac(o4c.p2.p2CompliantAdultCleaning),
      fromGoCarac(o4c.p2.p2CompliantAdultCompresses),
      fromGoCarac(o4c.p2.p2AdultAlcoolicAntiseptic),
      fromGoCarac(o4c.p2.p2AdultSpontaneousDrying),

      {
        f: o4c.p2.p2CompliantUltrasoundAtInsertion.key,
        t: `Échoguidage à l'insertion`,
        h: true
      },
      fromGoCarac(o4c.p2.p2CompliantUltrasoundAtInsertion),
      fromGoCarac(o4c.p2.p2UltrasoundSterileGelAndSheath),
      fromGoCarac(o4c.p2.p2UltrasoundCompliantAsepsis),
      fromGoCarac(o4c.p2.p2UltrasoundCompliantGloves)
    ],

    others: [
      {
        f: o4c.p2.p2TwoHDMCompliant.key,
        t: 'Hygiène des mains',
        h: true
      },
      fromGoCarac(o4c.p2.p2TwoHDMCompliant),
      fromGoCarac(o4c.p2.p2SterileGlovesIfPalpation),
      {
        f: o4c.p2.p2CompliantPedCleaning.key,
        t: 'Préparation cutanée',
        h: true
      },
      fromGoCarac(o4c.p2.p2CompliantPedCleaning),

      {
        f: o4c.p2.p2FirstHDMCompliant.key,
        t: 'Hygiène des mains',
        h: true
      },
      fromGoCarac(o4c.p2.p2FirstHDMCompliant),
      fromGoCarac(o4c.p2.p2SecondHDMCompliant),

      {
        f: o4c.p2.p2Gloves.key,
        t: 'Gants - Protection du professionnel',
        h: true
      },
      fromGoCarac(o4c.p2.p2Gloves),

      {
        f: o4c.p2.p2GlovesGoodTiming.key,
        t: 'Gants - Enfilage au bon moment',
        h: true
      },
      fromGoCarac(o4c.p2.p2GlovesGoodTiming)
    ]
  },

  p3: {
    indicators: [],

    highlights: [
      {
        f: o4c.p3.p3CompliantAuditedOutfitAndHDM.key,
        t: sc.titles.byTheme.adt,
        h: true
      },
      fromGoCarac(o4c.p3.p3CompliantAuditedOutfitAndHDM),
      fromGoCarac(o4c.p3.p3CompliantAuditedCap),
      fromGoCarac(o4c.p3.p3CompliantAuditedMask),
      fromGoCarac(o4c.p3.p3AuditedCleanOutfit),
      fromGoCarac(o4c.p3.p3CompliantAsepsis),

      {
        f: o4c.p3.p3CompliantPatientAdultOutfit.key,
        t: 'Tenue du patient / résident (adultes)',
        h: true
      },
      fromGoCarac(o4c.p3.p3CompliantPatientAdultOutfit),
      fromGoCarac(o4c.p3.p3PatientAdultCleanOutfit),
      fromGoCarac(o4c.p3.p3CompliantPatientAdultMaskOrTurned),

      {
        f: o4c.p3.p3CompliantAdultSkinPreparation.key,
        t: 'Préparation cutanée (adultes)',
        h: true
      },
      fromGoCarac(o4c.p3.p3CompliantAdultSkinPreparation),
      fromGoCarac(o4c.p3.p3CompliantAdultCleaning),
      fromGoCarac(o4c.p3.p3CompliantAdultCompresses),
      fromGoCarac(o4c.p3.p3AdultAlcoolicAntiseptic),
      fromGoCarac(o4c.p3.p3AdultSpontaneousDrying)
    ],

    others: [
      {
        f: o4c.p3.p3CompliantPedCleaning.key,
        t: 'Préparation cutanée',
        h: true
      },
      fromGoCarac(o4c.p3.p3CompliantPedCleaning),

      {
        f: o4c.p3.p3FirstHDMCompliant.key,
        t: 'Hygiène des mains',
        h: true
      },
      fromGoCarac(o4c.p3.p3FirstHDMCompliant),
      fromGoCarac(o4c.p3.p3SecondHDMCompliant),

      {
        f: o4c.p3.p3Gloves.key,
        t: 'Gants - Protection du professionnel',
        h: true
      },
      fromGoCarac(o4c.p3.p3Gloves)
    ]
  },

  p4: {
    indicators: [],

    highlights: [
      {
        f: o4c.p4.p4CompliantAuditedOutfitAndHDM.key,
        t: sc.titles.byTheme.adt,
        h: true
      },
      fromGoCarac(o4c.p4.p4CompliantAuditedOutfitAndHDM),
      fromGoCarac(o4c.p4.p4AuditedCleanOutfit),
      fromGoCarac(o4c.p4.p4CompliantAsepsis),

      {
        f: o4c.p4.p4CompliantPatientOutfit.key,
        t: 'Tenue du patient / résident',
        h: true
      },
      fromGoCarac(o4c.p4.p4CompliantPatientOutfit),

      {
        f: o4c.p4.p4CompliantAdultSkinPreparation.key,
        t: 'Préparation cutanée',
        h: true
      },
      fromGoCarac(o4c.p4.p4CompliantAdultSkinPreparation),
      fromGoCarac(o4c.p4.p4CompliantAdultCleaning),
      fromGoCarac(o4c.p4.p4CompliantAdultCompresses),
      fromGoCarac(o4c.p4.p4AdultAlcoolicAntiseptic),
      fromGoCarac(o4c.p4.p4AdultSpontaneousDrying)

    ],
    others: [
      {
        f: o4c.p4.p4FirstHDMCompliant.key,
        t: 'Hygiène des mains',
        h: true
      },
      fromGoCarac(o4c.p4.p4FirstHDMCompliant),
      fromGoCarac(o4c.p4.p4SecondHDMCompliant),

      {
        f: o4c.p4.p4Gloves.key,
        t: 'Gants - Protection du professionnel',
        h: true
      },
      fromGoCarac(o4c.p4.p4Gloves)
    ]
  },

  p5: {
    indicators: [],
    highlights: [],
    others: []
  },

  b1: {
    indicators: [],

    highlights: [
      {
        f: o4c.b1.b1CompliantAuditedOutfitAndHDM.key,
        t: sc.titles.byTheme.adt,
        h: true
      },

      fromGoCarac(o4c.b1.b1CompliantAuditedOutfitAndHDM),
      fromGoCarac(o4c.b1.b1AuditedCleanOutfit),
      fromGoCarac(o4c.b1.b1CompliantAsepsis),

      {
        f: o4c.b1.b1CompliantHookupSitePreparation.key,
        t: 'Préparation du site de branchement',
        h: true
      },
      fromGoCarac(o4c.b1.b1CompliantHookupSitePreparation),
      fromGoCarac(o4c.b1.b1CompliantCompresses),
      fromGoCarac(o4c.b1.b1Alcool70),
      fromGoCarac(o4c.b1.b1ValveDisinfection),
      fromGoCarac(o4c.b1.b1CompliantValveDisinfection),
      fromGoCarac(o4c.b1.b1ValveAlcool70),

      {
        f: o4c.b1.b1DiscontinuousSamplingCompliantRinsingTiming.key,
        t: 'Opportunité du rinçage pulsé',
        h: true
      },
      fromGoCarac(o4c.b1.b1DiscontinuousConnectionCompliantRinsingTiming),
      fromGoCarac(o4c.b1.b1DiscontinuousDisconnectionCompliantRinsingTiming),
      fromGoCarac(o4c.b1.b1DiscontinuousInjectionCompliantRinsingTiming),
      fromGoCarac(o4c.b1.b1DiscontinuousSamplingCompliantRinsingTiming),
      fromGoCarac(o4c.b1.b1ContinuousSamplingCompliantRinsingTiming),

      {
        f: o4c.b1.b1CompliantRinsingTechnique.key,
        t: 'Technique du rinçage pulsé',
        h: true
      },
      fromGoCarac(o4c.b1.b1CompliantRinsingTechnique),
      fromGoCarac(o4c.b1.b1CompliantRinsingProduct),
      fromGoCarac(o4c.b1.b1CompliantRinsingElimination)

    ],
    others: [
      {
        f: o4c.b1.b1Gloves.key,
        t: 'Gants - Protection du professionnel',
        h: true
      },
      fromGoCarac(o4c.b1.b1Gloves)
    ]
  },

  b2: {
    indicators: [
      {
        f: o4c.b2.b2CompliantAuditedOutfitAndHDMInCtr.key,
        t: 'Indicateurs de la stratégie nationale (CVC, PICC, cathéter de dialyse et CCI, secteur adulte)',
        h: true
      },
      fromGoCarac(o4c.b2.b2CompliantAuditedOutfitAndHDMInCtr),
      fromGoCarac(o4c.b2.b2CompliantPatientAdultOutfitInCtr),
      fromGoCarac(o4c.b2.b2CompliantHookupSitePreparationInCtr),

      {
        f: o4c.b2.b2CompliantAuditedOutfitAndHDMInMID.key,
        t: 'Indicateurs SPIADI (MIDLines avec prolongateur intégré, secteur adulte)',
        h: true
      },
      fromGoCarac(o4c.b2.b2CompliantAuditedOutfitAndHDMInMID),
      fromGoCarac(o4c.b2.b2CompliantPatientAdultOutfitInMID),
      fromGoCarac(o4c.b2.b2CompliantHookupSitePreparationInMID)
    ],

    highlights: [
      {
        f: o4c.b2.b2CompliantAuditedOutfitAndHDM.key,
        t: sc.titles.byTheme.adt,
        h: true
      },

      fromGoCarac(o4c.b2.b2CompliantAuditedOutfitAndHDM),
      fromGoCarac(o4c.b2.b2CompliantAuditedCap),
      fromGoCarac(o4c.b2.b2CompliantAuditedMask),
      fromGoCarac(o4c.b2.b2AuditedCleanOutfit),
      fromGoCarac(o4c.b2.b2CompliantAsepsis),

      {
        f: o4c.b2.b2CompliantPatientAdultOutfit.key,
        t: 'Tenue du patient / résident (adultes)',
        h: true
      },
      fromGoCarac(o4c.b2.b2CompliantPatientAdultOutfit),
      fromGoCarac(o4c.b2.b2PatientAdultCleanOutfit),
      fromGoCarac(o4c.b2.b2CompliantPatientAdultMaskOrTurned),

      {
        f: o4c.b2.b2CompliantHookupSitePreparation.key,
        t: 'Préparation du site de branchement',
        h: true
      },
      fromGoCarac(o4c.b2.b2CompliantHookupSitePreparation),
      fromGoCarac(o4c.b2.b2CompliantCompresses),
      fromGoCarac(o4c.b2.b2Alcool70),
      fromGoCarac(o4c.b2.b2ValveDisinfection),
      fromGoCarac(o4c.b2.b2CompliantValveDisinfection),
      fromGoCarac(o4c.b2.b2ValveAlcool70),

      {
        f: o4c.b2.b2DiscontinuousConnectionCompliantRinsingTiming.key,
        t: 'Opportunité du rinçage pulsé (utilisation du cathéter en discontinu)',
        h: true
      },
      fromGoCarac(o4c.b2.b2DiscontinuousConnectionCompliantRinsingTiming),
      fromGoCarac(o4c.b2.b2DiscontinuousDisconnectionCompliantRinsingTiming),
      fromGoCarac(o4c.b2.b2DiscontinuousInjectionCompliantRinsingTiming),
      fromGoCarac(o4c.b2.b2DiscontinuousSamplingCompliantRinsingTiming),
      fromGoCarac(o4c.b2.b2CCIDiscontinuousNeedleRemovalCompliantRinsingTiming),

      {
        f: o4c.b2.b2ContinuousSamplingCompliantRinsingTiming.key,
        t: 'Opportunité du rinçage pulsé (utilisation du cathéter en continu)',
        h: true
      },
      fromGoCarac(o4c.b2.b2ContinuousSamplingCompliantRinsingTiming),
      fromGoCarac(o4c.b2.b2CCIContinuousNeedleRemovalCompliantRinsingTiming),

      {
        f: o4c.b2.b2CompliantRinsingTechnique.key,
        t: 'Technique du rinçage pulsé',
        h: true
      },
      fromGoCarac(o4c.b2.b2CompliantRinsingTechnique),
      fromGoCarac(o4c.b2.b2CompliantRinsingProduct),
      fromGoCarac(o4c.b2.b2CompliantRinsingElimination)
    ],
    others: [
      {
        f: o4c.b2.b2CCINeedleRemovalCompliantRinsingTiming.key,
        t: 'Opportunité du rinçage pulsé (continu et discontinu)',
        h: true
      },
      fromGoCarac(o4c.b2.b2CCINeedleRemovalCompliantRinsingTiming)
    ]
  },

  r1: {
    indicators: [
      {
        f: o4c.r1.r1CompliantAuditedOutfitAndHDMInCtr.key,
        t: 'Indicateurs SPIADI (CVC, PICC et cathéter de dialyse de courte durée, secteur adulte)',
        h: true
      },
      fromGoCarac(o4c.r1.r1CompliantAuditedOutfitAndHDMInCtr),
      fromGoCarac(o4c.r1.r1CompliantPatientAdultOutfitInCtr),
      fromGoCarac(o4c.r1.r1CompliantAdultSkinPreparationInCtr),

      {
        f: o4c.r1.r1CompliantAuditedOutfitAndHDMInMID.key,
        t: 'Indicateurs SPIADI (MIDLines avec prolongateur intégré, secteur adulte)',
        h: true
      },
      fromGoCarac(o4c.r1.r1CompliantAuditedOutfitAndHDMInMID),
      fromGoCarac(o4c.r1.r1CompliantPatientAdultOutfitInMID),
      fromGoCarac(o4c.r1.r1CompliantAdultSkinPreparationInMID)
    ],

    highlights: [
      {
        f: o4c.r1.r1CompliantAuditedOutfitAndHDM.key,
        t: sc.titles.byTheme.adt,
        h: true
      },
      fromGoCarac(o4c.r1.r1CompliantAuditedOutfitAndHDM),
      fromGoCarac(o4c.r1.r1CompliantAuditedCap),
      fromGoCarac(o4c.r1.r1CompliantAuditedMask),
      fromGoCarac(o4c.r1.r1AuditedCleanOutfit),
      fromGoCarac(o4c.r1.r1CompliantAsepsis),

      {
        f: o4c.r1.r1CompliantPatientAdultOutfit.key,
        t: 'Tenue du patient / résident (adultes)',
        h: true
      },
      fromGoCarac(o4c.r1.r1CompliantPatientAdultOutfit),

      {
        f: o4c.r1.r1CompliantAdultSkinPreparation.key,
        t: 'Préparation cutanée (adultes)',
        h: true
      },
      fromGoCarac(o4c.r1.r1CompliantAdultSkinPreparation),
      fromGoCarac(o4c.r1.r1CompliantAdultCleaning),
      fromGoCarac(o4c.r1.r1CompliantAdultCompresses),
      fromGoCarac(o4c.r1.r1AdultAlcoolicAntiseptic),
      fromGoCarac(o4c.r1.r1AdultChlorexidine2Percent),
      fromGoCarac(o4c.r1.r1AdultSpontaneousDrying),
      fromGoCarac(o4c.r1.r1SystematicAdultCleaning)
    ],
    others: []
  }
}

export default (regions, year) => {
  const yt = yearTables[year]
  const yf = yearFields[year]
  const ll = [
    fromField('obsManagment', yf.obsManagment.all)
  ]

  if (regions) {
    ll.push(
      {
        f: o4c.p1.p1EtbSheetDist.key,
        t: o4c.p1.p1EtbSheetDist.title,
        minimizeDecimalScale: true
      },
      {
        f: o4c.p2.p2EtbSheetDist.key,
        t: o4c.p2.p2EtbSheetDist.title,
        minimizeDecimalScale: true
      },
      {
        f: o4c.p3.p3EtbSheetDist.key,
        t: o4c.p3.p3EtbSheetDist.title,
        minimizeDecimalScale: true
      },
      {
        f: o4c.p4.p4EtbSheetDist.key,
        t: o4c.p4.p4EtbSheetDist.title,
        minimizeDecimalScale: true
      },
      {
        f: o4c.b1.b1EtbSheetDist.key,
        t: o4c.b1.b1EtbSheetDist.title,
        minimizeDecimalScale: true

      },
      {
        f: o4c.b2.b2EtbSheetDist.key,
        t: o4c.b2.b2EtbSheetDist.title,
        minimizeDecimalScale: true
      },
      {
        f: o4c.r1.r1EtbSheetDist.key,
        t: o4c.r1.r1EtbSheetDist.title,
        minimizeDecimalScale: true
      },
      {
        f: o4c.p5.p5EtbSheetDist.key,
        t: o4c.p5.p5EtbSheetDist.title,
        minimizeDecimalScale: true
      }
    )
  }

  const table = [
    ...locDistribution(
      '', 'fiches', { estb: regions, open: true, year: year }
    ),
    {
      title: `Répartition des fiches`,
      key: 'general',
      open: true,
      list: ll
    }
  ]

  for (let sheet in yt) {
    const ys = yt[sheet]
    const i = indicators[sheet]
    if (i == null || ys == null) {
      continue
    }

    const label = sheet.toUpperCase()
    if (go.isBackOfficeClient()) {
      table.push(
        {
          title: `${label} - Indicateurs`,
          key: `${sheet}.indicators`,
          displayAllValues: true,
          list: i.indicators
        }
      )
    }

    table.push(
      {
        title: `${label} - Faits marquants`,
        key: `${sheet}.highlights`,
        displayAllValues: true,
        list: i.highlights
      },

      {
        title: `${label} - Autres conformités`,
        key: `${sheet}.others`,
        displayAllValues: true,
        list: i.others
      },

      {
        title: `${label} - Données brutes`,
        key: `${sheet}.data`,
        list: ys
      }
    )
  }

  return table
}
